import { Ajax, CrudApiBase } from "../infra";
import { Dataset, DatasetListItem, DatasetStatus } from "../../model";

/**
 * Provides CRUD access to datasets.
 */
export class Datasets extends CrudApiBase<Dataset, DatasetListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/datasets";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): Dataset {
    return {
      info: {
        status: DatasetStatus.Draft,
      },
      data: [],
      workflowData: {
        events: [],
      },
      usecase: {
        data: {},
      },
    };
  }
}
